<template>
  <div>
    <div class="row"
         style="justify-content: flex-end;align-items: center;margin-top:-32px;margin-bottom:30px">
      <el-input placeholder="请输入姓名"
                v-model="name"
                size="small"
                style="width:300px"
                clearable>
        <el-button slot="append"
                   @click="getProList"
                   icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div class="listbox">
      <table>
        <thead>
          <tr>
            <th style="width:80px">姓名</th>
            <th style="width:120px">手机号</th>
            <th>单位</th>
            <th style="width:90px">学习情况</th>
            <th style="width:170px">添加时间</th>
            <!-- <th style="width:90px">是否启用</th> -->
            <th style="width:80px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in storeList"
              :key="index">
            <td>{{item.userName}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.unit}}</td>
            <td>
              <a class="dela"
                 @click="toShowStatis(item.userId)"
                 href="javascript:0">详情</a>
            </td>
            <td>{{item.createDate}}</td>
            <!-- <td>
              <el-switch v-model="item.is_Start"
                         @change="changeStart(item.is_Start,item.userId)"
                         active-color="#0b8586"></el-switch>
            </td> -->
            <td>
              <el-popconfirm :title="'您确定要将'+item.userName+'移除吗？'"
                             @confirm="toDeleteResources(item.userId)">
                <a class="dela"
                   slot="reference"
                   href="javascript:0">移除</a>
              </el-popconfirm>
            </td>
          </tr>
          <tr v-show="storeList.length<1">
            <td colspan="6">
              <span>暂无数据，请前往</span>
              <a style="color:#0b8586"
                 @click="toStudent"
                 href="javascript:0">学员管理</a>
              <span>中操作</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="fenye"
         v-show="storeList.length>0">
      <pagination :total="pageCount"
                  :limit="pageSize"
                  :page="pageIndex"
                  style="margin-top:30px"
                  @page-change="pageChange"></pagination>
      <div class="tablesum">共 <span style="color:#0B8586">{{pageCount}}</span> 条</div>
    </div>
    <el-dialog title="课程完成进度明细"
               :visible.sync="isStatis"
               class="statis"
               width="856px">
      <el-table :data="statisList"
                max-height="420px"
                border>
        <el-table-column property="title"
                         label="课程名称"></el-table-column>
        <el-table-column label="完成进度"
                         width="100px">
          <template slot-scope="scope">
            <div class="timeBox">
              <span>{{Math.ceil(scope.row.learning*100)}}%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- <div class="tip">
      <span>注：添加成员请在学员管理中操作！</span>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
  },
  data () {
    return {
      orgid: 0,
      name: '',
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      storeList: [],
      isStatis: false,
      statisList: []
    };
  },
  created () {
    this.orgid = Number(localStorage.getItem('storeId'))
    this.getProList()
  },
  methods: {
    getShow () {
      this.httphelper
        .post('/api/EnterpriseApi/GetIntCourseUserPageList', {
          orgId: this.orgid,
          userName: this.name,
          page: this.pageIndex,
          limit: this.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data
            this.pageCount = res.data.totalcount
          }
        });
    },
    getProList () {
      this.pageIndex = 1
      this.getShow()
    },
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.getShow()
    },
    toDeleteResources (id) {
      this.httphelper.post('/api/EnterpriseApi/DelIntCourseUser', {
        orgId: this.orgid,
        userId: id
      })
        .then(res => {
          if (res.data.code == 200) {
            this.getShow()
            this.$message({
              message: '移除成功',
              type: 'success'
            });
          }
        });
    },
    // changeStart (status, id) {
    //   this.httphelper.post('/api/EnterpriseApi/UpdIntCourseShow', {
    //     id: id,
    //     status: status
    //   })
    //     .then(res => {
    //       if (res.data.code == 200) {
    //         if (status == true) this.$message.success('上架成功');
    //         if (status == false) this.$message.success('下架成功');
    //       }
    //     });
    // },
    toShowStatis (uid) {
      this.isStatis = true
      this.httphelper.get('/api/EnterpriseApi/GetIntCourseSchedList', {
        orgId: this.orgid,
        userId: uid
      })
        .then(res => {
          if (res.code == 200) {
            this.statisList = res.data
          }
        });
    },
    toStudent () {
      this.$router.push({
        path: '/userStore/student'
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.row {
    display: flex;
    margin-bottom: 20px;
}
.listbox {
    width: 100%;
    margin-top: 30px;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.tablesum {
    width: 80px;
    position: absolute;
    bottom: 16px;
    right: 0px;
    text-align: right;
}
.fenye {
    position: relative;
}
.dela {
    color: #0b8586;
    font-size: 12px;
}
.statis ::v-deep .el-dialog {
    padding: 50px 59px;
    position: relative;
}
.statis ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.statis ::v-deep .el-dialog__header {
    padding: 0;
}
.statis ::v-deep .el-dialog__body {
    height: 100%;
    padding: 0;
    padding-top: 20px;
    box-sizing: border-box;
}
.statis ::v-deep th {
    background: #edfafa;
}
.statis ::v-deep td,
.statis ::v-deep th {
    padding: 8px 0 !important;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.tip {
    font-size: 14px;
    line-height: 40px;
}
</style>